// Shared constants for issue field value mutations
export const ISSUE_FIELD_VALUES_PAGE_SIZE = 25
